'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { PAGAMENTO_POLLING_BACKOFF_FATOR, PAGAMENTO_POLLING_INTERVALO_MAX_MS, PAGAMENTO_POLLING_INTERVALO_MS, PAGAMENTO_POLLING_TETO_MS } from '@/shared/constants/pagamentoPolling';
import { proximoIntervaloComBackoff } from '@/shared/utils/proximoIntervaloComBackoff';
import { consultarPagamentoSelf, marcarPollingPagamentoExpirado, selectSelfConsultandoPagamento, selectSelfPollingPagamentoExpirado, selectSelfStep } from '../store';
import type { AbortableThunk } from '../types';
export const usePagamentoSelfPolling = () => {
  const $ = _c(13);
  const dispatch = useAppDispatch();
  const step = useAppSelector(selectSelfStep);
  const consultandoPagamento = useAppSelector(selectSelfConsultandoPagamento);
  const pollingExpirado = useAppSelector(selectSelfPollingPagamentoExpirado);
  let t0;
  if ($[0] !== consultandoPagamento || $[1] !== dispatch) {
    t0 = () => {
      if (consultandoPagamento) {
        return null;
      }
      return dispatch(consultarPagamentoSelf());
    };
    $[0] = consultandoPagamento;
    $[1] = dispatch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const consultar = useEffectEvent(t0);
  let t1;
  if ($[3] !== dispatch) {
    t1 = () => dispatch(marcarPollingPagamentoExpirado());
    $[3] = dispatch;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const expirar = useEffectEvent(t1);
  let t2;
  if ($[5] !== consultar || $[6] !== expirar || $[7] !== pollingExpirado || $[8] !== step) {
    t2 = () => {
      if (step !== "waitingPayment" || pollingExpirado) {
        return;
      }
      let consultaEmVoo = null;
      let proximoIntervalo = PAGAMENTO_POLLING_INTERVALO_MS;
      let decorrido = 0;
      let agendamento;
      const disparar = () => {
        consultaEmVoo = consultar() ?? consultaEmVoo;
      };
      const agendarProximaConsulta = () => {
        agendamento = setTimeout(() => {
          decorrido = decorrido + proximoIntervalo;
          decorrido;
          if (decorrido > PAGAMENTO_POLLING_TETO_MS) {
            expirar();
            return;
          }
          disparar();
          proximoIntervalo = proximoIntervaloComBackoff(proximoIntervalo, PAGAMENTO_POLLING_BACKOFF_FATOR, PAGAMENTO_POLLING_INTERVALO_MAX_MS);
          agendarProximaConsulta();
        }, proximoIntervalo);
      };
      disparar();
      agendarProximaConsulta();
      return () => {
        clearTimeout(agendamento);
        consultaEmVoo?.abort();
      };
    };
    $[5] = consultar;
    $[6] = expirar;
    $[7] = pollingExpirado;
    $[8] = step;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== pollingExpirado || $[11] !== step) {
    t3 = [step, pollingExpirado];
    $[10] = pollingExpirado;
    $[11] = step;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  useEffect(t2, t3);
};